export enum PaymentMode {
  Daily = '001',
  Monthly = '003',
  Quarterly = '004',
  Annually = '005',
  Half_Yearly = 2,
  Single = 99,
  Fortnightly = 15,
}
